import { useSearchParams } from "@solidjs/router";
import { createMemo, Match, Show, Switch } from "solid-js";
import { useOnboardingStore } from "../context/OnboardingContext";
import { parseEditStep } from "../utils/review-edit";
import { EditStepView } from "./EditStepView";
import { Education } from "./steps/Education";
import { Experience } from "./steps/Experience";
import { Info } from "./steps/Info";
import { JobTitle } from "./steps/JobTitle";
import { Locale } from "./steps/Locale";
import { OnlinePrecense } from "./steps/OnlinePrecense";
import { Review } from "./steps/Preview";
import { Pricing } from "./steps/Pricing";
import { Sector } from "./steps/Sector";
import { Skills } from "./steps/Skills";
import { Summary } from "./steps/Summary";

export const ManualOnboarding = (props: { bottomInset?: number }) => {
  const [store] = useOnboardingStore();
  const [searchParams] = useSearchParams();
  const editStep = createMemo(() =>
    store.step === "review" ? parseEditStep(searchParams.edit) : null,
  );
  return (
    <Switch>
      <Match when={store.step === "sector"}>
        <Sector bottomInset={props.bottomInset} />
      </Match>
      <Match when={store.step === "skills"}>
        <Skills />
      </Match>
      <Match when={store.step === "job_title"}>
        <JobTitle />
      </Match>
      <Match when={store.step === "experience"}>
        <Experience />
      </Match>
      <Match when={store.step === "education"}>
        <Education />
      </Match>
      <Match when={store.step === "locale"}>
        <Locale />
      </Match>
      <Match when={store.step === "summary"}>
        <Summary />
      </Match>
      <Match when={store.step === "pricing"}>
        <Pricing />
      </Match>
      <Match when={store.step === "info"}>
        <Info />
      </Match>
      <Match when={store.step === "online-presence"}>
        <OnlinePrecense />
      </Match>
      <Match when={store.step === "review"}>
        <Show when={editStep()} fallback={<Review />}>
          {(step) => (
            <EditStepView step={step()} bottomInset={props.bottomInset} />
          )}
        </Show>
      </Match>
    </Switch>
  );
};
